import { ShotStatus } from "../types";

export const BID_ITEM_STATUSES: ShotStatus[] = [
  "Bidding",
  "Off",
  "Lost",
  "Awarded",
  "Rebid",
  "Overage",
  "Invoiced",
];

export function getBidStatusClasses(status?: ShotStatus | null) {
  if (status === "Bidding") return "bg-purple-50 text-purple-700 border-purple-200";
  if (status === "Off") return "bg-slate-50 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700";
  if (status === "Lost") return "bg-rose-50 text-rose-700 border-rose-200";
  if (status === "Awarded") return "bg-emerald-50 text-emerald-700 border-emerald-200";
  if (status === "Rebid") return "bg-orange-50 text-orange-700 border-orange-200";
  if (status === "Overage") return "bg-amber-50 text-amber-700 border-amber-200";
  if (status === "Invoiced") return "bg-sky-50 text-sky-700 border-sky-200";
  return "bg-white text-slate-700 border-slate-200 dark:bg-slate-900 dark:text-slate-200 dark:border-slate-700";
}

export function isExcludedBidStatus(status?: ShotStatus | null) {
  return status === "Lost" || status === "Off";
}

export function isBidItemIncluded(item: { active: boolean; status?: ShotStatus | null }) {
  if (item.status) return !isExcludedBidStatus(item.status);
  return item.active;
}

export function getBidStatusValue(item: { active: boolean; status?: ShotStatus | null }) {
  if (item.status) return item.status;
  return item.active ? "Bidding" : "Off";
}

export function normalizeImportedBidStatus(value: unknown): ShotStatus | null {
  if (value === null || value === undefined) return null;

  const raw = String(value).trim();
  if (!raw) return null;

  const normalized = raw.toLowerCase().replace(/[^a-z0-9]/g, "");

  if (normalized === "bidding") return "Bidding";
  if (normalized === "deselected" || normalized === "inactive" || normalized === "off") return "Off";
  if (normalized === "lost") return "Lost";
  if (normalized === "awarded") return "Awarded";
  if (normalized === "rebid") return "Rebid";
  if (normalized === "overage") return "Overage";
  if (normalized === "invoiced") return "Invoiced";

  if (["true", "yes", "on", "1", "checked", "selected", "active"].includes(normalized)) return "Bidding";
  if (["false", "no", "0", "unchecked", "unselected"].includes(normalized)) return "Off";

  return null;
}
